import { Button, ModalWindow, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import { useIsMobileDevice } from '../../hooks';
import { useToggleState } from '../../hooks/useToggleState';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';
import { ModalContent, ModalHeader } from './components/ModalContent';
import { CADASTRAL_ADDRESS_TITLE } from './constants';
import * as styles from './RosreestrData.css';
import { IRosreestrDataProps } from './types';

export const RosreestrData: React.FC<IRosreestrDataProps> = ({ address, cardView, onDataShow }) => {
  const [modalOpened, toggleModalOpened] = useToggleState();
  const isMobile = useIsMobileDevice();

  React.useEffect(() => {
    if (modalOpened) {
      onDataShow();
    }
  }, [modalOpened, onDataShow]);

  return (
    <div>
      <UIHeading4 as="h4">Получили данные из Росреестра по адресу:</UIHeading4>
      {Object.entries(address).map(([key, addressText]) => (
        <div className={classNames(styles['address-container'], isMobile && styles['mobile'])} key={key}>
          <UIText2 color="gray60_100" as="p">
            {CADASTRAL_ADDRESS_TITLE[key as ECadastralFieldsNames]}
          </UIText2>
          <UIText1 as="p">{addressText}</UIText1>
        </div>
      ))}
      <div className={classNames(styles['button-container'], isMobile && styles['mobile'])}>
        <Button theme="fill_secondary" onClick={toggleModalOpened} size="XS" type="button">
          Показать больше
        </Button>
      </div>
      <ModalWindow
        title="Данные из Росреестра"
        open={modalOpened}
        header={<ModalHeader />}
        onClose={toggleModalOpened}
        width={844}
        content={<ModalContent parts={cardView.parts} />}
      />
    </div>
  );
};
